/* eslint-disable no-useless-escape */
export const REG_EXP = {
  ONLY_UNDERBAR_BRACKET: /[\{\}\[\]\/?.,;:|*~`!^\-\+<>@\#$%&\\\=\'\"]/gi,
  ONLY_DIGIT: /^[0-9]+$/gm,
  NOT_INCLUDE_HYPHEN: /^((?!-).)*$/gm,
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PASSWORD_INCLUDE_CHAR: /(?=.*?[a-zA-Z])/,
  PASSWORD_INCLUDE_NUMBER: /(?=.*?[0-9])/,
  PASSWORD_INCLUDE_SPECIAL_CHAR: /(?=.*?[#?!@$%^&*-])/,
  FROM_TWO_DAYS_TO_YEAR: /^[2-9]{1}$|^[1-9]{1}[0-9]{1}$|^[1-2]{1}[0-9]{1}[0-9]{1}$|^3[0-6]{1}[0-5]{1}$/,
  PASSWORD: /^(?=.*[a-zA-Z])(?=.*?[#?!@$%^&*-])(?=.*[0-9]).{8,20}$/,
};

export const checkRegExpRule = (key: keyof typeof REG_EXP, value: string) => {
  const regExp = getRegExp(REG_EXP[key]);
  return regExp.test(value);
};

const getRegExp = (key: RegExp) => {
  return new RegExp(key);
};
